import React from 'react';
import ButtonTwo from '../../components/Button/ButtonTwo';
import SingleBlogTwo from '../../components/Blog/SingleBlogTwo';

import blogImg1 from '../../assets/img/blog/blog-5-1.jpg';
import blogImg2 from '../../assets/img/blog/blog-5-2.jpg';

const Blog = () => {
  return (
    <div
      id="it-blog"
      className="it-blog-2-area it-blog-style-3 p-relative pt-120 pb-90"
    >
      <div className="container">
        <div className="row gx-35 align-items-center">
          <div className="col-xl-4 col-lg-4 col-md-6">
            <div className="it-blog-title-box">
              <span className="it-section-subtitle red-border">Our Blog</span>
              <h3 className="it-section-title">
                Our Latest <br /> News & Blogs
              </h3>
              <div className="it-blog-2-text mt-20 mb-40">
                <p>
                  Neque porro quisquam est, qui dolorem ipsum quia dolor sit
                  amet, consectetur, adipisci velit, sed quia nonm.
                </p>
              </div>
              <ButtonTwo
                btnURL="/blog"
                btnClass="it-btn-theme red-bg mr-35"
                btnText="All Blog"
              />
            </div>
          </div>
          <div className="col-xl-4 col-lg-4 col-md-6 mb-30">
            <SingleBlogTwo
              blogImage={blogImg1}
              publishedDate="15 JUNE, 24"
              titleClass="hover-anim red"
              title="Healthcare Tips Navigating Business Patient Care"
              description="Lorem ipsum dolor sit a met, consectetur adipiscing elit, sed
                  eiusmod tempor incididunt ut labore et dolore magna aliqua."
              hasArrow
            />
          </div>
          <div className="col-xl-4 col-lg-4 col-md-6 mb-30">
            <SingleBlogTwo
              blogImage={blogImg2}
              publishedDate="24 May, 24"
              titleClass="hover-anim red"
              title="Preserving Care Strategy Amidst Food Changes"
              description="Lorem ipsum dolor sit a met, consectetur adipiscing elit, sed
                  eiusmod tempor incididunt ut labore et dolore magna aliqua."
              hasArrow
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Blog;
